var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-user-avatar"},[_c('img',{attrs:{"src":_vm.newUserAvatar,"alt":_vm.userName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }